import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex flex-col justify-between"
};
const _hoisted_2 = {
  class: "w-full"
};
const _hoisted_3 = {
  class: "w-full pt-2"
};
export default {
  __name: 'StatusPaymentFilter',
  props: {
    form: {
      type: Object,
      required: false
    }
  },
  emits: ["statusChange"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const paymentStatusChange = () => {
      emit("statusChange");
    };
    const invoiceTypeChange = () => {
      emit("statusChange");
    };
    const paymentStatusList = [{
      id: "paid",
      label: "Paid"
    }, {
      id: "partiallyPaid",
      label: "Partially Paid"
    }, {
      id: "unPaid",
      label: "Unpaid"
    }];
    const messageTypeList = [{
      id: 'invoiceemail',
      label: "Invoice"
    }, {
      id: "",
      label: "All"
    }, {
      id: "trustRequestEmail",
      label: "Trust Request"
    }];
    return (_ctx, _cache) => {
      const _component_v_autocomplete = _resolveComponent("v-autocomplete");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = _createElementVNode("label", {
        class: "py-1 text-sm"
      }, "Status", -1)), _createVNode(_component_v_autocomplete, {
        modelValue: __props.form.paymentStatus,
        "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => __props.form.paymentStatus = $event), _cache[1] || (_cache[1] = $event => paymentStatusChange($event))],
        items: paymentStatusList,
        density: "compact",
        "item-title": "label",
        "item-value": "id",
        class: "at-choose-client remove-outline",
        "return-object": "",
        clearable: "",
        searchable: "",
        placeholder: "Select Payment Status",
        variant: "outlined",
        "hide-details": "true",
        "data-cy": "payment-status-autocomplete"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_3, [_cache[5] || (_cache[5] = _createElementVNode("label", {
        class: "py-1 text-sm"
      }, "Type", -1)), _createVNode(_component_v_autocomplete, {
        modelValue: __props.form.messageType,
        "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => __props.form.messageType = $event), _cache[3] || (_cache[3] = $event => invoiceTypeChange($event))],
        items: messageTypeList,
        density: "compact",
        "item-title": "label",
        "item-value": "id",
        class: "at-choose-matter remove-outline",
        "return-object": "",
        clearable: "",
        placeholder: "Invoice",
        variant: "outlined"
      }, null, 8, ["modelValue"])])]);
    };
  }
};